import {RootState} from '../../../store/store';
import {useSelector} from 'react-redux';

function selector(state: RootState) {
    return state.globalAirplane;
}

export function useGlobalAirplane() {
  return useSelector<RootState, ReturnType<typeof selector>>(selector);
}
